<template>
  <div>
    <homehero class="limit">
    </homehero>

    <navigationgrid :showing="[true,true,true,true,false]"></navigationgrid>

    
    <iconslider></iconslider>
  </div>
</template>

<script>
import homehero from "@/components/homehero.vue";
import fullimage from "@/components/fullimage.vue";
import navigationgrid from "@/components/navigationgrid.vue";
import navigationcard from "@/components/navigationcard.vue";
import wwdfooter from "@/components/wwdfooter.vue";
import maincontent from "@/components/maincontent.vue";
import iconslider from "@/components/IconSlider.vue";

export default {
  components: {
    homehero: homehero,
    fullimage: fullimage,
    navigationgrid: navigationgrid,
    navigationcard: navigationcard,
    wwdfooter: wwdfooter,
    maincontent: maincontent,
    iconslider: iconslider
  }
};
</script>
